module.exports = __webpack_public_path__ + "img/events_1.edf1f30b.jpg";